import { useTranslation } from 'react-i18next'

import { FailedIcon } from '@arcade/web/icons/react'
import {
  ArcadeButton,
  ArcadeIconMat,
  ArcadePageHeader,
  Button,
  IconMat,
  spacing,
  Stack,
} from '@cash-design-system/react'
import { useArcadeMigrationFeatureFlag } from '@cash-web/shared-data-access-arcade-migration'

const goToSupport = () => {
  window.open('/support', '_blank')
}

export const ModalErrorContent = ({
  title,
  message,
  showSupportButton = true,
}: {
  title?: string
  message?: string
  showSupportButton?: boolean
}) => {
  const { t } = useTranslation()
  const isArcadeMigrationEnabled = useArcadeMigrationFeatureFlag('apps')

  if (isArcadeMigrationEnabled) {
    return (
      <Stack space={spacing.xxl}>
        <ArcadePageHeader
          asset={{
            avatar: (
              <ArcadeIconMat variant="danger">
                <FailedIcon size={32} />
              </ArcadeIconMat>
            ),
          }}
          title={title ?? t('Something went wrong', { context: 'modal title' })}
          titleElement="h1"
          body={message ?? t('Try again or contact support.', { context: 'modal body text' })}
        />
        {showSupportButton && (
          <ArcadeButton onClick={goToSupport} prominence="standard" size="cta">
            {t('Contact Support', { context: 'button text' })}
          </ArcadeButton>
        )}
      </Stack>
    )
  }

  return (
    <Stack space={spacing.xxl}>
      <ArcadePageHeader
        asset={{
          avatar: (
            <IconMat variant="danger">
              <FailedIcon size={32} />
            </IconMat>
          ),
        }}
        title={title ?? t('Something went wrong', { context: 'modal title' })}
        titleElement="h1"
        body={message ?? t('Try again or contact support.', { context: 'modal body text' })}
      />
      {showSupportButton && (
        <Button size="large" variant="secondary" onClick={goToSupport}>
          {t('Contact Support', { context: 'button text' })}
        </Button>
      )}
    </Stack>
  )
}
